import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import HeroSection from './sections/HeroSection';
import BeddingSection from './sections/BeddingSection';
import PillowsSection from './sections/PillowsSection';
import BathSection from './sections/BathSection';
import FragranceSection from './sections/FragranceSection';
import SeoCopySection from './sections/SeoCopySection';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection />
      <BeddingSection />
      <PillowsSection />
      <BathSection />
      <FragranceSection />
      <SeoCopySection />
    </div>
  );
};

export default Home;
